export function retornaServicosParaInserirOuDeletar(idsServicosSelecionados, idsServicosCadastrados){
    const naoContemNoArray1 = idsServicosSelecionados.filter(id  => !idsServicosCadastrados.includes(id));

    const naoContemNoArray2 = idsServicosCadastrados.filter(id => !idsServicosSelecionados.includes(id) );

    return [naoContemNoArray1, naoContemNoArray2];
}
